import React, { useEffect, useState } from "react";
import { Bell } from "lucide-react";
import { api } from "@/lib/wolfApi";

export const HypeListPanel = () => {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/merch/notify/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  if (!stats) return null;
  const max = Math.max(1, ...stats.product_interest.map((p) => p.count));

  return (
    <div className="mt-6 bg-[#111111] border border-[#D4AF37]/25 p-6" data-testid="hype-list-panel">
      <p className="text-[10px] uppercase tracking-[0.32em] text-[#D4AF37]/90 mb-3">— Merch Hype List · Admin</p>
      <div className="flex items-end gap-3">
        <span className="font-display text-4xl text-[#D4AF37]" data-testid="hype-list-total">{stats.total}</span>
        <span className="text-[11px] uppercase tracking-[0.25em] text-white/50 pb-1.5 inline-flex items-center gap-1.5">
          <Bell size={12} className="text-[#D4AF37]/70" /> on the list
        </span>
      </div>
      {stats.notified > 0 && (
        <p className="text-[10px] uppercase tracking-[0.25em] text-white/40 mt-1">{stats.notified} already notified</p>
      )}

      {stats.product_interest.length > 0 && (
        <div className="mt-5 border-t border-white/10 pt-4">
          <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-3">Most wanted</p>
          <ul className="space-y-3" data-testid="hype-list-products">
            {stats.product_interest.slice(0, 6).map((p) => (
              <li key={p.product_id}>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-white/85">{p.name}</span>
                  <span className="text-[#D4AF37] font-display">{p.count}</span>
                </div>
                <div className="mt-1 h-1 bg-white/5">
                  <div className="h-full bg-[#D4AF37]/70" style={{ width: `${(p.count / max) * 100}%` }} />
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}

      {stats.recent.length > 0 && (
        <div className="mt-5 border-t border-white/10 pt-4">
          <p className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-3">Latest signups</p>
          <ul className="space-y-1.5" data-testid="hype-list-recent">
            {stats.recent.map((s) => (
              <li key={s.email} className="text-xs text-white/60 truncate">{s.email}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
